<template>
    <section id="bar-menu-wrapper" class="generic-wrapper">
        <h1 class="page-title">Nuestro Menú en el Bar</h1>

        <vue-picture-swipe 
                id="bar-menu-images"
                :items="images" 
                class="img-thumbnails"/>
    </section>
</template>

<script>
import VuePictureSwipe from 'vue-picture-swipe';

export default {
    name: 'BarMenu',
    components: {VuePictureSwipe},
    data() {
        return {
            images: [
                {
                    src: require('../assets/images/bar-menu/menu-1.jpg'),
                    thumbnail: require('../assets/images/bar-menu/scaled/menu-1.jpg'),
                    w: 2550,
                    h: 3300,
                    alt: 'Menú del Bar 1'
                },
                {
                    src: require('../assets/images/bar-menu/menu-2.jpg'),
                    thumbnail: require('../assets/images/bar-menu/scaled/menu-2.jpg'),
                    w: 2550,
                    h: 3300,
                    alt: 'Menú del Bar 2'
                },
                {
                    src: require('../assets/images/bar-menu/menu-3.jpg'),
                    thumbnail: require('../assets/images/bar-menu/scaled/menu-3.jpg'),
                    w: 2550,
                    h: 3300,
                    alt: 'Menú del Bar 3'
                },
                {
                    src: require('../assets/images/bar-menu/menu-4.jpg'),
                    thumbnail: require('../assets/images/bar-menu/scaled/menu-4.jpg'),
                    w: 2550,
                    h: 3300,
                    alt: 'Menú del Bar 4'
                },
                {
                    src: require('../assets/images/bar-menu/menu-5.jpg'),
                    thumbnail: require('../assets/images/bar-menu/scaled/menu-5.jpg'),
                    w: 2550,
                    h: 3300,
                    alt: 'Menú del Bar 5'
                },
                {
                    src: require('../assets/images/bar-menu/menu-6.jpg'),
                    thumbnail: require('../assets/images/bar-menu/scaled/menu-6.jpg'),
                    w: 2550,
                    h: 3300,
                    alt: 'Menú del Bar 6'
                },
            ]
        }
    }
}
</script>

<style scoped>
#bar-menu-wrapper {
    padding-left: 0;
    padding-right: 0;
}

#bar-menu-images {
    width: 90%;
    margin: auto;
}
</style>
